import React from 'react'

function Avatar({
  url,
  size,
  tag,
  className,
}: {
  url: string
  size?: string
  tag?: 'div' | 'span'
  className?: string,
  fallbackUrl?:string;
}): React.ReactElement {
  const _size = size ?? 'lg'
  const Tag = tag ?? 'div'

  return (
    <Tag className={`avatar _${_size} ${className ?? ''}`.trim()}>
      {url ? <img src={url} alt="avatar" /> : <span className='avatar__fallback' /> }
    </Tag>
  )
}

export default Avatar
